import React from 'react';
import { BaseLayout } from './BaseLayout';
import { layoutConfigs } from './layoutConfigs';
import { PartnerSidebar } from './PartnerSidebar';

interface PartnerLayoutProps {
  children: React.ReactNode;
}

export const PartnerLayout: React.FC<PartnerLayoutProps> = ({ children }) => {
  return (
    <BaseLayout
      sidebar={<PartnerSidebar />}
      config={{
        ...layoutConfigs.partner,
        // Partner usa p-8 ao invés de px-8 pb-4
        paddingClassName: undefined, // usar default do BaseLayout
      }}
    >
      {children}
    </BaseLayout>
  );
};
